<template>
        <button class="btn demand-share-btn" @click="onClick">
            <icon-base icon-name="truck" width="24" height="24" viewbox="0 0 24 24">
                <icon-share/>
            </icon-base>
            <!-- Share -->
        </button>
</template>

<script>
import IconBase from './IconBase.vue'
import IconShare from './icons/IconShare.vue'

export default {
    name: 'ShareButton',
    components: {
        IconBase,
        IconShare,
    },
    methods: {
        onClick() {
            this.$emit('on-click')
        }
    }
}
</script>